module.exports = __webpack_public_path__ + "static/media/Fusion 360.7d266411.png";